/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No drivers found matching your search.`)
};

const es_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron pilotos que coincidan con tu búsqueda.`)
};

const de_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Fahrer gefunden, die deiner Suche entsprechen.`)
};

const nl_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen coureurs gevonden die overeenkomen met je zoekopdracht.`)
};

const fr_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun pilote trouvé correspondant à votre recherche.`)
};

const it_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun pilota trovato corrispondente alla ricerca.`)
};

const pt_br2_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum piloto encontrado para sua busca.`)
};

const pt_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum piloto encontrado para a sua pesquisa.`)
};

const ja_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索に一致するドライバーが見つかりません。`)
};

const zh_f1_standings_no_drivers_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到符合搜索的车手。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_no_drivers_search = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_no_drivers_search(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_no_drivers_search", locale)
	if (locale === "en") return en_f1_standings_no_drivers_search(inputs)
	if (locale === "es") return es_f1_standings_no_drivers_search(inputs)
	if (locale === "de") return de_f1_standings_no_drivers_search(inputs)
	if (locale === "nl") return nl_f1_standings_no_drivers_search(inputs)
	if (locale === "fr") return fr_f1_standings_no_drivers_search(inputs)
	if (locale === "it") return it_f1_standings_no_drivers_search(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_no_drivers_search(inputs)
	if (locale === "pt") return pt_f1_standings_no_drivers_search(inputs)
	if (locale === "ja") return ja_f1_standings_no_drivers_search(inputs)
	return zh_f1_standings_no_drivers_search(inputs)
};